/**
 * Shared date helpers for joinee forms (mirrors server/utils/dateHelpers.js).
 */
import dayjs from "dayjs";

export function isValidDateValue(value) {
  if (value === null || typeof value === "undefined" || value === "") {
    return false;
  }
  var d = dayjs(value);
  return d.isValid();
}

/** Prefer saved date; only use today when nothing was stored yet. */
export function preferSavedDate(savedDate, fallbackToday) {
  if (isValidDateValue(savedDate)) {
    return savedDate;
  }
  if (typeof fallbackToday === "string" && fallbackToday) {
    return fallbackToday;
  }
  return new Date().toISOString();
}

export function ageInYearsFromDob(dobValue, asOfDate) {
  if (!isValidDateValue(dobValue)) {
    return "";
  }
  var dob = dayjs(dobValue);
  var asOf = isValidDateValue(asOfDate) ? dayjs(asOfDate) : dayjs();
  var years = asOf.diff(dob, "year");
  return years < 0 ? "" : years;
}

export function isFutureDate(value) {
  if (!isValidDateValue(value)) {
    return false;
  }
  return dayjs(value).isAfter(dayjs(), "day");
}

export function isPastDateOnly(value) {
  if (!isValidDateValue(value)) {
    return false;
  }
  return dayjs(value).isBefore(dayjs(), "day");
}
